import React from 'react';
import './Watchlist.scss';

const Watchlist = () => {
  return(
    <section id='watchlist-main'>
      <h2 id='section-title'>Coming Soon!</h2>
    </section>
  )
}

export default Watchlist;